/* eslint-disable*/
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer,
} from 'recharts';
import getScreenSize from '../utils/getScreenSize';
import { formatCurrency } from '../utils/shared';
interface CustomTooltipProps {
  active?: boolean;
  payload?: {
    name: string;
    value: number;
    payload: {
      name: string;
      value: number;
    };
  }[];
  currency?: boolean;
}

interface DataPoint {
  name: string;
  pv: number;
}

interface BarChartProps {
  data: DataPoint[];
  currency?: boolean;
}

const CustomTooltip = ({ active, payload, currency }: CustomTooltipProps) => {
  if (active && payload && payload.length) {
    return (
                    <div className="bg-surface-base p-2 rounded-md shadow-md">
        <p className="label font-medium text-text-primary">{payload[0].payload.name}</p>
        <p className="text-sm text-text-secondary">{currency ? formatCurrency(payload[0].value) : payload[0].value}</p>
      </div>
    );
  }
  return null;
};

const CustomBarChart = ({ data, currency }: BarChartProps) => {

  const determineFontSize = () => {
    if (data.length < 4) {
      return 16;
    }
    if (data.length < 6) {
      return 14;
    }
    if (data.length < 8) {
      return 12;
    }
    return 10;
  };

  const determineInterval = () => {
    if (getScreenSize() === 'sm' || getScreenSize() === 'md' || getScreenSize() === 'xs') {
      return 1;
    }
    return 0;
  };

  const hasValidData = data.length > 0 && data.some(item => item.pv !== null && item.pv !== undefined);

  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        {hasValidData ? <BarChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 0" vertical={false} stroke='rgb(var(--color-border-secondary))' />
          <XAxis
            dataKey="name"
            stroke='rgb(var(--color-text-secondary))'
            tick={{ fill: 'rgb(var(--color-text-secondary))', fontSize: determineFontSize(), width: 60, overflow: 'hidden' }}
            tickFormatter={(value) => {
              return value.length > 10 ? `${value.substring(0, 10)}...` : value;
            }}
            interval={determineInterval()}
          />
          <YAxis stroke='rgb(var(--color-text-secondary))' tick={{ fill: 'rgb(var(--color-text-secondary))', fontSize: determineFontSize() }} />
          <Tooltip
            content={<CustomTooltip currency={currency} />}
            cursor={{ fill: 'rgb(var(--color-surface-secondary))', opacity: 0.7 }}
          />
          <Bar dataKey="pv" fill='rgb(var(--color-primary-500))' barSize={40} radius={[10, 10, 0, 0]} />
        </BarChart>
          :
          <div className='flex flex-col items-center justify-center h-full'>
            <p className='text-text-secondary'>No hay datos</p>
          </div>}
      </ResponsiveContainer>
    </div>
  );
};

export default CustomBarChart;
